/** @file Create-bone tool registration: title and activation chord B (viewport context). */
import type { ToolDef } from '../../stores/types';

/** Draws new bones under the selected bone. */
export const tool: ToolDef = { id: 'createBone', title: 'tools.createBone.title', bindings: [{ id: 'tool.createBone', keys: 'KeyB', context: 'viewport' }] };
